import { KEY } from "./reducer";
import { getPlaygroundOptionById } from "domain/Directories/selectors";

export const getState = (state) => state[KEY] || {};

export const getPlaygrounds = (state) => getState(state).items || {};

export const getPlaygroundById = (state, id) => getPlaygrounds(state)[id];

export const getPlaygroundOptionsOnWords = (state, playgroundId) =>
    (getPlaygroundById(state, playgroundId).options || []).map((optionId) =>
        getPlaygroundOptionById(state, optionId)
    );
